import Router from "next/router"
import { useEffect, type PropsWithChildren, type FC } from "react"
import { posthog } from "posthog-js"
import { PostHogProvider } from "posthog-js/react"

import { isProductionEnv } from "common/constants/env"

export const PHProvider: FC<PropsWithChildren> = ({ children }) => {
  // Init posthog when app is ready/mounted
  useEffect(() => {
    if (isProductionEnv) {
      // Skip init for production env
      return
    }

    if (!process.env.NEXT_PUBLIC_POSTHOG_KEY) {
      return
    }

    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      // eslint-disable-next-line camelcase
      api_host:
        process.env.NEXT_PUBLIC_POSTHOG_HOST ?? "https://us.i.posthog.com",
      // eslint-disable-next-line camelcase
      person_profiles: "identified_only",
      // Enable debug mode in development
      loaded: (posthog) => {
        if (process.env.NODE_ENV === "development") posthog.debug()
      },
      autocapture: true,
    })

    const handleRouteChange = () => posthog?.capture("$pageview")

    Router.events.on("routeChangeComplete", handleRouteChange)

    return () => {
      Router.events.off("routeChangeComplete", handleRouteChange)
    }
  }, [])

  if (isProductionEnv) return <>{children}</>

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}
